// frontend/src/utils/itemLocationRowId.js
//
// One composition of the item-location row identity, because three places
// have to agree on it and nothing makes them: the forecast grid stamps it on
// every row (`rowId`), useGridChartScope derives the drilled row's id from
// the drill-down scope, and the grids' `*-row-active` cellClassRules compare
// the two. A separator changed in one of them would not fail a test — the
// highlight would just stop appearing.

/**
 * @param {string} itemCode
 * @param {string} locationCode
 * @returns {string} identity of one item-location row
 */
export function itemLocationRowId(itemCode, locationCode) {
  return `${itemCode}_${locationCode}`;
}
